import { useEffect, useState } from "react";
import { applyTheme, getStoredTheme, ThemeId } from "./themes";

/** Returns [current theme id, setter]. Persists + applies on change. */
export function useTheme(): [ThemeId, (id: ThemeId) => void] {
  const [theme, setTheme] = useState<ThemeId>(() => getStoredTheme());

  useEffect(() => {
    applyTheme(theme);
  }, [theme]);

  // sync across tabs / external changes
  useEffect(() => {
    const onChange = (e: Event) => {
      const detail = (e as CustomEvent).detail;
      if (detail?.id && detail.id !== theme) setTheme(detail.id);
    };
    window.addEventListener("woxa:theme-change", onChange);
    return () => window.removeEventListener("woxa:theme-change", onChange);
  }, [theme]);

  return [theme, setTheme];
}
